import { Box, Button } from "@saviynt/design-system";
import { useState } from "react";
import { useIntl } from "react-intl";

import { SaveViewMenu, SaveViewModal } from "./component";
import { useGetSaveViewList } from "../../hooks/usePolicySaveFilterView";
function SaveView() {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = useGetSaveViewList();
  const viewList = data ?? [];
  const hasSavedViews = viewList.length > 0;

  return (
    <Box className="ml-auto pt-4">
      {hasSavedViews ? (
        <SaveViewMenu setIsModalOpen={setIsModalOpen} saveViewList={viewList} />
      ) : (
        <Button
          isLoading={isLoading}
          kind="subtle"
          onClick={() => setIsModalOpen(true)}
        >
          {intl.formatMessage({
            description:
              "Button text for saving current policies filter and sort preferences as a custom view",
            defaultMessage: "Save View",
            id: "Pr5nlj",
          })}
        </Button>
      )}
      <SaveViewModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </Box>
  );
}

export default SaveView;
